import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Roslagsbanan")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("DEVELOPMENT")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_AppAccountDropdown = _resolveComponent("AppAccountDropdown")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "q-py-md" }, {
    default: _withCtx(() => [
      _createVNode(_component_AppLogo),
      _createVNode(_component_q_toolbar_title),
      _createVNode(_component_q_badge, {
        color: "grey-4",
        class: "q-pa-sm text-black"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_ctx.user.IsDev)
        ? (_openBlock(), _createBlock(_component_q_badge, {
            key: 0,
            color: "red",
            class: "q-pa-sm text-white q-ml-md"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      _createVNode(_component_AppAccountDropdown)
    ]),
    _: 1
  }))
}